import * as React from 'react';

import CampaignAssetsUpload from '../upload/CampaignAssetsUpload';
import CampaignAssetsGalleryItem from './CampaignAssetsGalleryItem';
import InspirationalMaterialsModal
  from 'modules/campaigns-inspirational-materials/components/inspirational-materials-modal/InspirationalMaterialsModal';

import { withModal } from 'components/modal/ModalHOC';

import { prepareCampaignAssetsForGallery } from 'utils/campaignAsset';
import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';

const CampaignAssetsUploadWithModal = withModal(CampaignAssetsUpload, {
  modalContent: InspirationalMaterialsModal,
  positionOverride: 'centered-no-padding'
});

const DivWithModal = withModal(<div />, WITH_GALLERY_MODAL_CONFIG);

import type { CampaignAsset } from 'types';

type Props = {
  canEdit: boolean,
  assets: Array<CampaignAsset>,
  onDeleteAsset: (a: CampaignAsset) => void
};

const CampaignAssetsGallery = ({
  canEdit,
  assets,
  onDeleteAsset
}: Props) => {
  const galleryItems = prepareCampaignAssetsForGallery(assets);

  return (
    <section className="assets-grid-gallery">
      <ul className="assets-grid-gallery__items">
        {
          canEdit &&
            <li className="assets-grid-gallery__item assets-grid-gallery__item--upload">
              <CampaignAssetsUploadWithModal />
            </li>
        }
        {
          assets.map((asset, index) => (
            <DivWithModal
              modalContentProps={{
                items: galleryItems,
                currentPosition: index
              }}
              key={`inspirational-material-${asset.id}`}
            >
              <CampaignAssetsGalleryItem
                asset={asset}
                canEdit={canEdit}
                onDeleteAsset={onDeleteAsset}
              />
            </DivWithModal>
          ))
        }
      </ul>
    </section>
  );
};

export default CampaignAssetsGallery;
